import {
  Container,
  Header,
  SpaceBetween,
  TextContent,
} from "@cloudscape-design/components-themed";
import { LABELS } from "../constants";
import InfoField from "../../UI/InfoField";
import { ReferenceGroupForBankAccount } from "../../../features/api-interfaces";
import { COMMON_LABELS } from "../../default-constants";

interface IReferenceGroup {
  referenceGroup?: ReferenceGroupForBankAccount;
}

/**
 * 入金口座情報照会・更新 参照グループ
 */
export const ReferenceGroup = (props: IReferenceGroup) => {
  const { referenceGroup } = props;

  /**
   * HD事業者の参照グループIDを表示する
   */
  const displayHdReferenceGroupId = () => (
    <>
      {referenceGroup?.hdReferenceGroupId && (
        <TextContent>
          <SpaceBetween direction={"horizontal"} size={"xxxs"}>
            <p>{COMMON_LABELS.LEFT_PARENTHESIS + "　"}</p>
            <h4>{LABELS.HD_REFERENCE_GROUPS_ID}</h4>
            <p>
              {COMMON_LABELS.COLON +
                referenceGroup?.hdReferenceGroupId +
                "　" +
                COMMON_LABELS.RIGHT_PARENTHESIS}
            </p>
          </SpaceBetween>
        </TextContent>
      )}
    </>
  );

  return (
    <Container
      header={<Header variant={"h2"}>{LABELS.REFERENCE_GROUP_TITLE}</Header>}
    >
      <SpaceBetween direction={"horizontal"} size={"xxl"}>
        <InfoField
          direction={"vertical"}
          size={"xxs"}
          tag={"h4"}
          values={[LABELS.REFERENCE_GROUPS_ID, LABELS.REFERENCE_GROUPS_NAME]}
        />
        <InfoField
          direction={"vertical"}
          size={"xxs"}
          tag={"p"}
          values={[
            referenceGroup?.referenceGroupId,
            referenceGroup?.referenceGroupName,
          ]}
        />
        {displayHdReferenceGroupId()}
      </SpaceBetween>
    </Container>
  );
};
